import React from 'react';
import { connect } from 'react-redux';

import { useIntl } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/ui.duck';

import { LayoutSingleColumn, Page } from '../../components';

import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import LegalDocument from '../_marketingPage/LegalDocument';

import privacyPolicyDocument from './privacyPolicyDocument';

/**
 * The privacy policy body on its own, without the page chrome. Also shown in
 * the sign-up page's privacy modal, so the same text sits in both places.
 *
 * The text is the client's document (Personvern_Zuprize_081026.docx),
 * verbatim, in the PrivacyPolicyPage.* translation keys.
 *
 * @returns {JSX.Element}
 */
export const PrivacyPolicyContent = () => (
  <LegalDocument document={privacyPolicyDocument} tocLabelId="PrivacyPolicyPage.tocEyebrow" />
);

/**
 * Privacy policy ("Personvernerklæring") page, `/personvern`.
 *
 * @param {Object} props
 * @param {boolean} props.scrollingDisabled
 * @returns {JSX.Element}
 */
const PrivacyPolicyPageComponent = props => {
  const intl = useIntl();
  const { scrollingDisabled } = props;

  return (
    <Page
      title={intl.formatMessage({ id: 'PrivacyPolicyPage.metaTitle' })}
      description={intl.formatMessage({ id: 'PrivacyPolicyPage.metaDescription' })}
      scrollingDisabled={scrollingDisabled}
    >
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <PrivacyPolicyContent />
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => ({
  scrollingDisabled: isScrollingDisabled(state),
});

const PrivacyPolicyPage = connect(mapStateToProps)(PrivacyPolicyPageComponent);

export { PrivacyPolicyPageComponent };
export default PrivacyPolicyPage;
